import i18next from "i18next";
import { initReactI18next } from "react-i18next";

i18next.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                menu: {
                    home: "Home",
                    blog: "Blog",
                    contact: "Contact"
                },
                meta: {
                    title: "VeridianAI",
                    description: "Innovative AI Solutions"
                },
                hero: {
                    title: "Revolution in technology with VeridianAi",
                    description: "We provide cutting-edge solutions in the field of AI and automation for your business",
                    contact: "Contact",
                },
                sponsors:{
                    title: "Companies that trust us",
                },

                faq: {
                    title: "FAQs",
                    description: "Find answers to common questions about our AI solutions, implementation process, and how we can help transform your business with cutting-edge technology. Can't find what you're looking for? Contact our team for personalized assistance.",
                    section1: {
                        title: "What are the benefits of AI solutions for my business?",
                        content: "AI solutions can enhance efficiency, reduce costs, improve decision-making, and personalize customer experiences. They automate repetitive tasks, provide valuable insights through data analysis, and help businesses stay competitive in a fast-evolving market."
                    },
                    section2: {
                        title: "How long does it take to implement automation processes?",
                        content: "The timeline for automation implementation varies depending on the complexity of the processes and system integration requirements. Simple automation can be set up within a few weeks, while more advanced solutions may take a few months for full deployment and optimization."
                    },
                    section3: {
                        title: "Are your cloud services secure?",
                        content: "Yes, our cloud services are secure. We use the latest encryption and security measures to protect your data."
                    }
                },
                prices: {
                    title: "Prices",
                    description: "Choose the plan that best suits your needs and budget.",
                    section1: {
                        title: "1 month payment",
                        price: "10 €",
                        description: "Pay as you go, with the flexibility to cancel anytime.",
                        item1: "1000 articles",
                        item2: "100 requests per day",
                        item3: "5000 tokens per month"
                    },
                    section2: { 
                        title: "1 year payment",
                        price: "100 €",
                        description: "Commit for a year and enjoy significant savings.",
                        item1: "10.000 articles",
                        item2: "500 requests per day",
                        item3: "50.000 tokens per month"
                    }
                },
                references: {
                    title: "References",
                    description: "What our clients say about us",
                    slide1: {
                        title: "Michael Chen, CTO, TechForward Solutions",
                        text: "Working with VeridianAI transformed our data analytics capabilities. Their innovative approach helped us reduce processing time by 60% while maintaining exceptional accuracy. The team's expertise and professionalism exceeded our expectations."
                    },
                    slide2: {
                        title: "Sarah Rodriguez, Director of Innovation, GreenPath Industries",
                        text: "VeridianAI's sustainable AI solutions have revolutionized our manufacturing processes. We've seen a 40% reduction in energy consumption and significant improvements in production efficiency. Their commitment to environmental responsibility aligns perfectly with our values."
                    },
                    slide3: {
                        title: "Dr. James Wilson, Head of Research, HealthTech Global",
                        text: "In the healthcare sector, precision is paramount. VeridianAI's machine learning models have dramatically improved our diagnostic accuracy rates. Their understanding of both AI and healthcare challenges makes them an invaluable partner."
                    },
                    slide4: {
                        title: "Lisa Thompson, Operations Manager, SmartScale Analytics",
                        text: "The implementation of VeridianAI's solutions was seamless. Their team provided exceptional support throughout the process, and the results speak for themselves - a 75% improvement in prediction accuracy and significant cost savings."
                    },
                    slide5: {
                        title: "Robert Kovalski, CEO, FutureFinance Ltd",
                        text: "As a financial services provider, we needed a partner who understood both AI and regulatory compliance. VeridianAI delivered sophisticated solutions while maintaining the highest security standards. Their work has given us a competitive edge in the market."
                    }
                },

                blog: {
                    title: "Blog Posts",
                    description: "Latest articles about AI and automation",
                    loading: "Loading...",
                    readMore: "Read More",
                    postNotFound: "Post not found",
                    backToBlog: "Back to Blog",
                    returnToBlog: "Return to Blog List"
                },
                contact: {
                    title: "Contact us",
                    description: "For questions or assistance, you can contact us by email.",
                },
                
                footer:{
                    description: "This website was created as a fictional example and all information provided is fictional.",
                    copy: "Copyright © 2025",
                    madeBy: "made by",
                    socialTitle: "Socials",
                    
                }
            }
        },
        sk: {
            translation: {
                menu: {
                    home: "Domov",
                    blog: "Blog",
                    contact: "Kontakt"
                },
                meta: {
                    title: "VeridianAI",
                    description: "Inovatívne AI Riešenia"
                },
                hero: {
                    title: "Revolúcia v technológiách s VeridianAi",
                    description: "Poskytujeme špičkové riešenia v oblasti AI a automatizácie pre vašu firmu",
                    contact: "Kontakt",
                },
                sponsors:{
                    title: "Spoločnosti, které nám dôverujú",
                },
                faq: {
                    title: "Často kladené otázky",
                   description: "Nájdite odpovede na bežné otázky o našich AI riešeniach, procese implementácie a o tom, ako môžeme pomôcť transformovať váš podnik pomocou najmodernejších technológií. Nenašli ste, čo hľadáte? Kontaktujte náš tím pre osobnú asistenciu.",
                    section1: {
                        title: "Aké sú výhody AI riešení pre moju firmu?",
                        content: "AI riešenia môžu zvýšiť efektivitu, znížiť náklady, zlepšiť rozhodovanie a personalizovať zákaznícky skúsenosti. Automatizujú opakujúce sa úlohy, poskytujú cenné informácie prostredníctvom analýzy dát a pomáhajú firme zostať v súkromí v rýchlo sa meniacom trhu."
                    },
                    section2: {
                        title: "Ako dlho trvá implementácia automatizačných procesov?",
                        content: "Čas implementácie automatizačných procesov sa líši v závislosti od komplexnosti procesov a požiadaviek na integráciu systémov. Jednoduché automatizácie môžu byť nastavené do niekoľkých týždňov, zatiaľ čo pokročilejšie riešenia môžu trvať niekoľko mesiacov pre úplné nasadenie a optimalizáciu."
                    },
                    section3: {
                        title: "Sú vaše cloudové služby bezpečné?",
                        content: "Áno, naše cloudové služby sú bezpečné. Používame najnovšie šifrovanie a bezpečnostné opatrenia na ochranu vašich údajov."
                    }
                },
                prices: {
                    title: "Cenník",
                    description: "Vyberte si plán, ktorý najlepšie vyhovuje vašim potrebám a rozpočtu.",
                    section1: {
                        title: "1 mesiac platby",
                        price: "10 €",
                        description: "Plaťte priebežne s možnosťou kedykoľvek zrušiť službu.",
                        item1: "1000 článkov",
                        item2: "100 žiadostí denne",
                        item3: "5000 tokenov mesačne"
                    },
                    section2: {
                        title: "1 rok platby",
                        price: "100 €",
                        description: "Zaviažte sa na rok a ušetrite značné sumy.",
                        item1: "10.000 článkov",
                        item2: "500 žiadostí denne",
                        item3: "50.000 tokenov mesačne"
                    }
                },
                references: {
                    title: "Referencie",
                    description: "Čo o nás hovoria naši klienti",
                    slide1: {
                        title: "Michael Chen, CTO, TechForward Solutions",
                        text: "Spolupráca s VeridianAI transformovala naše možnosti analýzy dát. Ich inovatívny prístup nám pomohol znížiť čas spracovania o 60% pri zachovaní výnimočnej presnosti. Odbornosť a profesionalita tímu predčila naše očakávania."
                    },      
                    slide2: {
                        title: "Sarah Rodriguez, Direktor inovácií, GreenPath Industries",
                        text: "Udržateľné AI riešenia od VeridianAI zrevolučnili naše výrobné procesy. Zaznamenali sme 40% zníženie spotreby energie a výrazné zlepšenie efektivity výroby. Ich záväzok k environmentálnej zodpovednosti dokonale zodpovedá našim hodnotám."
                    },
                    slide3: {
                        title: "Dr. James Wilson, Hlavný vedúci výskumu, HealthTech Global",
                        text: "V zdravotníctve je presnosť prvoradá. Modely strojového učenia VeridianAI dramaticky zlepšili našu diagnostickú presnosť. Ich porozumenie výzvam v oblasti AI aj zdravotníctva z nich robí neoceniteľného partnera."
                    },  
                    slide4: {
                        title: "Lisa Thompson, Manažér operácií, SmartScale Analytics",
                        text: "Implementácia VeridianAI's riešení prebehla hladko. Ich tím poskytol mimoriadne podporu počas procesu a výsledky hovoria sám za seba - 75% zvýšenie presnosti predikcie a významné úspory."
                    },
                    slide5: {
                        title: "Robert Kovalski, CEO, FutureFinance Ltd",
                        text: "Ako finančná služba poskytujeme partnerovi, ktorý rozumie obom AI a regulatórnym dokumentom. VeridianAI dodal inteligentné riešenia pri zachovaní najvyšších bezpečnostných štandardov. Ich práca nám dala hranu v rámci trhu."
                    }
                },
                blog: {
                    title: "Blog Príspevky",
                    description: "Články o najnovších trendoch v AI a automatizácii.",
                    loading: "Načítava sa...",
                    readMore: "Čítať viac",
                    postNotFound: "Príspevok nebol nájdený",
                    backToBlog: "Späť na blog",
                    returnToBlog: "Späť na zoznam príspevkov"
                },
                contact: {
                    title: "Kontaktujte nás",
                    description: "V prípade otázok alebo potreby pomoci, nám môžete napísať email.",
                },
                
                footer:{
                    description: "Táto webová stránka bola vytvorená ako fiktívny príklad a všetky informácie na nej uvedené sú vymyslené.",
                    copy: "Copyright © 2025",
                    madeBy: "Vytvoril",
                    socialTitle: "Sociálne siete",
                }
            }
        },

    },
    lng: "en", 
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    }
});

export default i18next; 